// import { addNewToast } from '@pkg/components/Toast/useToastStore';
import { type Account } from '@pkg/graphql/codegen/graphql';
// import { getErrorMessage } from '@pkg/utils';

import { reactQueryClient } from '@app/reactQueryClient';

import { useAuthTokens } from '../auth/useAuthTokens';

import { callGetConnectedWalletsByUser } from './request';
import { useWalletStore } from './useWalletStore';
import { USER_WALLETS_BY_USER_CACHE } from './useWalletsQueryById';

export async function initializeWallets(userId?: string) {
    const currentUserId = userId || useAuthTokens.getState().currentUserId;
    if (!currentUserId) return;

    // TODO: This needs to be fetched from useWalletsQueryById.
    // Cache key was modified to prevent a clash with that other query
    // (causing this one to fail).
    try {
        const walletData = await reactQueryClient.fetchInfiniteQuery({
            queryKey: [USER_WALLETS_BY_USER_CACHE, currentUserId, 'initialize'],
            queryFn: ({ signal, pageParam }) =>
                callGetConnectedWalletsByUser({
                    variables: {
                        userFilter: { current: true },
                        cursorInput: {
                            limit: 100,
                            cursor: pageParam || null,
                        },
                    },
                    settings: { signal },
                }),
            initialPageParam: '',
            staleTime: Infinity,
        });
        if (walletData) {
            const wallets =
                walletData?.pages.flatMap((data) => data?.accounts?.accounts).filter((w) => w !== undefined) || [];
            useWalletStore.getState().setWallets(wallets as Account[]);
        }
    } catch (e) {
        // TODO: This is currently outputting a huge error on console
        // related to GraphQL: https://nomatter.tari.com/tari/pl/9osu64n8hjbt7cpdx3eiwsg9ow
        // const message = getErrorMessage(e);
        // addNewToast({ message, minimal: true });
    }
}
